<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
    <rect class="cls-1" x="0" y="0" width="90.07" height="90.07"/>
    <g>
        <g>
            <circle class="cls-2" cx="12.49" cy="45.16" r="3.34"/>
            <line class="cls-2" x1="15.83" y1="45.16" x2="30.85" y2="45.16"/>
            <circle class="cls-2" cx="34.19" cy="45.16" r="3.34"/>
            <line class="cls-2" x1="37.53" y1="45.16" x2="52.55" y2="45.16"/>
            <circle class="cls-2" cx="55.88" cy="45.16" r="3.34"/>
            <line class="cls-2" x1="59.22" y1="45.16" x2="74.24" y2="45.16"/>
            <circle class="cls-2" cx="77.58" cy="45.16" r="3.34"/>
        </g>
        <g>
            <polygon class="cls-4" points="64.37 80.77 64.37 57.26 59.57 57.26 55.88 53.38 52.35 57.26 47.4 57.26 47.4 80.77 64.37 80.77"/>
            <g>
                <line class="cls-3" x1="60.61" y1="74.9" x2="51.16" y2="74.9"/>
                <line class="cls-3" x1="60.61" y1="68.6" x2="51.16" y2="68.6"/>
                <line class="cls-3" x1="60.61" y1="62.3" x2="51.16" y2="62.3"/>
            </g>
        </g>
        <g>
            <polygon class="cls-4" points="42.67 9.3 42.67 32.81 37.87 32.81 34.18 36.69 30.65 32.81 25.7 32.81 25.7 9.3 42.67 9.3"/>
            <g>
                <line class="cls-3" x1="38.91" y1="27.62" x2="29.46" y2="27.62"/>
                <line class="cls-3" x1="38.91" y1="21.32" x2="29.46" y2="21.32"/>
                <line class="cls-3" x1="38.91" y1="15.02" x2="29.46" y2="15.02"/>
            </g>
        </g>
    </g>
</svg>
</template>

<script>
export default {
    name: "PerformanceTimelineIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    stroke: #115c72;
  }
  .cls-2, .cls-3 {
    stroke-linejoin: round;
  }
  .cls-2, .cls-3, .cls-4 {
    fill: none;
    stroke-width: 2px;
  }
  .cls-3 {
    stroke: #cfeae0;
    stroke-linecap: round;
  }
  .cls-4 {
    stroke: #59c5c7;
    stroke-miterlimit: 10;
  }
</style>